import type { ArbitrumRunRecord } from "../components/arbitrum/run-surface-types";

const STORAGE_KEY = "fintheon:arbitrum-live-run:v1";

export interface LiveArbitrumRunContext {
  id: string;
  title: string;
  generatedAt: string;
  presetLabels: string[];
  synthesisMarkdown: string;
  docsPacketTitle: string;
  narrativePromptTitle: string;
  riskFlowPacketTitle: string;
}

export function writeLiveArbitrumRun(run: ArbitrumRunRecord): void {
  const context: LiveArbitrumRunContext = {
    id: run.id,
    title: run.report.title,
    generatedAt: run.report.generatedAt,
    presetLabels: run.report.presetLabels,
    synthesisMarkdown: run.synthesisMarkdown,
    docsPacketTitle: run.handoffPackets.docsPacket.title,
    narrativePromptTitle: run.handoffPackets.narrativePromptPacket.title,
    riskFlowPacketTitle: run.handoffPackets.riskFlowPacket.title,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    window.dispatchEvent(
      new CustomEvent("fintheon:arbitrum-live-run", { detail: context }),
    );
  } catch {
    /* Optional browser storage can be unavailable in shell previews. */
  }
}

export function readLiveArbitrumRun(): LiveArbitrumRunContext | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<LiveArbitrumRunContext>;
    if (!parsed.id || !parsed.title) return null;
    return {
      id: parsed.id,
      title: parsed.title,
      generatedAt: parsed.generatedAt ?? "",
      presetLabels: Array.isArray(parsed.presetLabels)
        ? parsed.presetLabels.filter(
            (item): item is string => typeof item === "string",
          )
        : [],
      synthesisMarkdown: parsed.synthesisMarkdown ?? "",
      docsPacketTitle: parsed.docsPacketTitle ?? "",
      narrativePromptTitle: parsed.narrativePromptTitle ?? "",
      riskFlowPacketTitle: parsed.riskFlowPacketTitle ?? "",
    };
  } catch {
    return null;
  }
}
